<template>
  <!-- 公司项目 -->
  <div id="enterprise-card2">
    <slot name="title"></slot>
    <slot name="content"></slot>
    <div
      class="enterprise-card2-pagination"
      v-if="information.activeName !== 'emil'"
    >
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="information.pageData.pageIndex"
        :page-size="information.pageData.pageSize"
        layout="prev, pager, next"
        :total="information.pageData.totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    information: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      checkList: ["有微信"],
      pageData: {
        currentPage: 1,
        pageSize: 10,
        total: 20,
      },
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", this.information);
    },
  },
};
</script>

<style lang="less" scoped>
#enterprise-card2 {
  .enterprise-card2-search {
    width: 100%;
  }
  .enterprise-card2-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .box-card {
      width: 49%;
      margin-bottom: 10px;
      .box-card-avatar {
        img {
          width: 40px;
          height: 40px;
        }
      }
      .box-card-content {
        text-align: left;
        margin-left: 12px;
        .box-card-content-title {
          font-weight: 500;
          font-size: 18px;
          line-height: 18px;
          color: #111a34;
        }
        .box-card-content-subtitle {
          height: 14px;
          font-size: 14px;
          margin-top: 3px;
          color: #777e95;
        }
        .box-card-content-des {
          height: 60px;
          max-height: 60px;
          font-size: 14px;
          margin-top: 12px;
          color: #777e95;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .enterprise-card2-pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
